// extracted by mini-css-extract-plugin
export default {"root":"LoginInfoModal_root__SPy6O"};